import React from "react";
import Header from "../../components/Header/LandingHeader";
import s from "./Committee.module.scss";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import Team from "../../components/Team/Team";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import useWindowDimensions from "../../components/WindowDimentions/WindowDimentions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import PageTitle from "../../components/PageTitle/PageTitle";

const Committee = () => {
  const { width } = useWindowDimensions();
  return (
    <div className={s.committee}>
      <div>{width > 1000 ? <Header /> : <MobileHeader />}</div>
      <PageTitle className={s.h2} eyebrow="Advisory Committee" title="Members of the Board of the Middle Corridor Transit Advisory Committee" />
      <div className={s.text}>
        <div className={s.text_section}>
          <div>
            <strong>
              The Middle Corridor Transit Advisory Committee (MCTAC)
            </strong>
            , also known as the &quot;The Board of the Committee,&quot; is a
            community of experts from Middle Corridor countries dedicated to
            sharing knowledge and experience, specializing in trade
            facilitation, digital trade, business development, customs
            clearance, cross-border process management, AEO programs, logistics,
            and customs brokerage services.
          </div>
          <div>
            The Board of the Committee members are approved by the MCTAC&#39;s
            supreme body, the{" "}
            <strong>
              National Customs Association of the Republic of Moldova.
            </strong>
          </div>
          <div>
            The Advisory Committee is comprised of qualified and experienced
            professionals with extensive experience in the aforementioned areas,
            including international cooperation in trade facilitation in
            general.
          </div>
          <div>
            Council members specialize in the following areas: <br />
            <br /> - Trade facilitation and legal support for business
            development <br /> - Logistics, transit corridors, and cross-border
            process management
            <br /> - Customs clearance and control <br /> - Digital trade,
            digital transformation, and e-services
            <br /> - Customs risk management <br /> - Authorized economic
            operator (AEO)
          </div>

          <div>
            The Council is the highest body of the Advisory Committee and makes
            strategic decisions.
          </div>
        </div>
      </div>
      <Team />

      <LandingFooter />
      <ScrollToTop />
    </div>
  );
};

export default Committee;
